import { render } from "./ListeLivraison.vue?vue&type=template&id=04659646&ts=true"
import script from "./ListeLivraison.vue?vue&type=script&lang=ts"
export * from "./ListeLivraison.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__